import { AuditAvl_AuditProperty } from '../../core/models/AuditAvl_AuditProperty-model'
import { AuditAvl_AuditSchedule } from '../../core/models/AuditAvl_AuditSchedule-model'

export class AuditAvl_Audit
{
    AuditID:string;
    Name:string;
    RACFilters:string;
    PlacedOnQueue:Date;
    SabrePCC:string;
    RateAccessType:string;
    AuditAmadeus:boolean;
    AuditApollo:boolean;
    AuditGalileo:boolean;
    AuditSabre:boolean;
    AuditWorldspan:boolean;
    Dateselected:String[]=[];
    PropSelected: AuditAvl_AuditProperty[]=[];
    AuditSchedule:AuditAvl_AuditSchedule[]=[];

}
